<template>
  <main>
    <tab-condition-header />
    <div class="tab-content">
      <div class="tab-pane active show">

        <!-- 查詢列表 -->
        <search-list 
        v-show="status==='STATUS_SEARCH_LIST'"
        :status="status"
        @change-status="changeStatus"
        @open-edit="openEdit"
        @open-effect="openEffect"
        />

        <!-- 成效 -->
        <effectiveness
        :status="status"
        :effect-data="effectData"
        v-show="status==='STATUS_EFFECTIVENESS'"
        @change-status="changeStatus"
        />

        <!-- 修改 -->
        <release-table
        v-show="status==='STATUS_EDIT_UNIT'"
        :edit-status="true"
        :edit-data="edit_data"
        :ch-text="option_ch"
        :title="condition_title"
        :status="status"
        @change-status="changeStatus"/>

      </div>
    </div>

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { debuglog } from 'util';
// components
import TabConditionHeader from './components/TabConditionHeader'
import SearchList from './components/SearchList'
import Effectiveness from './components/Effectiveness'
import ReleaseTable from '@/desktop/views/manager/condition/components/ReleaseTable'

export default {
  name: 'ConditionTabl',
  mixins: [commonMixin],
  components: {
    TabConditionHeader, SearchList, Effectiveness, ReleaseTable
  },
  computed: {
  },
  data () {
    return {
      status: 'STATUS_SEARCH_LIST',
      option_ch: '',
      edit_data: {},
      condition_title: '',
      effectData: {},
    }
  },

  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    changeStatus(type) {
      this.status = type
    },
    openEdit (type, item) {
      this.status = type
      this.edit_data = {...item}
      this.option_ch = item.option_ch.join(';')
      this.condition_title = item.title
    },
    openEffect (type, item) {
      this.status = type
      this.effectData = {...item}
    },
  },
  mounted () {
      
  }
}
</script>
